import { getToken, setToken, getOrganizationCode, getPlatformCode } from '@/utils/utils'
import { Message } from 'element-ui'
import router from "@/router"

import axios from "axios"
const service = axios.create()
service.defaults.baseURL = process.env.API_ROOT
service.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8"

let lastConfig = null

service.download = function(url, body) {
  function download_callback (response) {
    let fileName = decodeURIComponent(response.headers['content-disposition'] ? response.headers['content-disposition'].match(/filename=(\S*)/)[0].substring("filename=".length) : "export.xls");

    let url = window.URL.createObjectURL(response.data);
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }
  if (body) {
    service.post(url, body,{responseType: 'blob'}).then(response => {
      download_callback(response)
    }).catch((error) => {
    })
  }
  else {
    service.get(url, {responseType: 'blob'}).then(response => {
      download_callback(response)
    }).catch((error) => {
    })
  }
}

    // 添加请求拦截器
service.interceptors.request.use(function(config) {
    // 在发送请求之前做些什么
    // config.headers['OrganizationCode'] = 'YY0000310318065'
    // config.headers['inner'] = 'jiansu'
    if (config.url.indexOf('login') === -1) {
        config.headers['Authorization'] = getToken()
        config.headers['OrganizationCode'] = getOrganizationCode()
        config.headers['platformCode'] = getPlatformCode()
    }
    lastConfig = config
    return config;
}, function(error) {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error);
});

/**
 * 拦截器提示
 * @param {String} msg  提示消息
 */
function message(msg) {
  Message({
    message: msg,
    type: 'error',
    duration: 2 * 1000
  })
}

// 添加响应拦截器
service.interceptors.response.use((response) => {
    // 对响应数据做点什么
    if (response.data.rc === 1001) {
        setToken(response.data.data)
        return service(lastConfig)
    }
    return response
}, (error) => {
    // 对响应错误做点什么
    // console.log(error.response.status)
    switch (error.response.status) {
      case 401:
        message('未授权，请先登录')
        setTimeout(() => {
          router.replace({ path: "/auth/login" })
        }, 1000)
        break;
      case 403:
        message('未鉴权，请先登录')
        setTimeout(() => {
          router.replace({ path: "/auth/login" })
        }, 1000)
        break;
      case 404:
        message('找不到页面')
        break;
      case 405:
        message('请求方式错误')
        break;
      case 500:
        message('服务器内部错误')
        break;
      case 502:
        message('网关错误')
        break;
      default:
        message('服务器开小差啦')
    }
    return Promise.reject(error)
})
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js